<template>
  <div>
    <ExpenseForm ref="expenseForm" :currencyAmount="currencyAmount" />
    <ItemTable
      ref="itemTable"
      :statementData="statementData"
      @updateTotAmount="(e) => (currencyAmount = e)"
    />
  </div>
</template>

<script>
import ExpenseForm from './form.vue'
import ItemTable from './table.vue'
export default {
  components: { ExpenseForm, ItemTable },
  props: {
    statementData: { type: Array, default: () => [] },
  },
  data() {
    return {
      currencyAmount: 0,
    }
  },
  methods: {
    async getData() {
      if (!(await this.validate())) return false
      const form = this.$refs.expenseForm.getData()
      const listItem = this.$refs.itemTable.getTableData()
      return { ...form, listItem }
    },
    async validate() {
      const formResult = await this.$refs.expenseForm.formValidate()
      const itemTableResult = await this.$refs.itemTable.validate()
      return formResult && itemTableResult
    },
  },
}
</script>
